
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AnchoredComponent from '../AnchoredComponent';
import Loader from 'react-loader';
import styles from './DownloadForm.css';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { DL_SERVICE_URL } from '../../config';
import { SetModalTitle, SetModalVisible } from '../../actions';
import withStyles from '../../decorators/withStyles';
import { setContactCookie, getContactCookie, cookieFieldMap, submitForm } from "../../utils/utils";
import { owlSend, gaEvent } from "../../utils/utils";

const d3 = require('d3');


class DownloadForm extends AnchoredComponent {

  static propTypes = {
    id: PropTypes.string.isRequired,
    productID: PropTypes.string.isRequired,
    dlType: PropTypes.string.isRequired,
    dlCallback: PropTypes.func.isRequired,
  };

  static defaultProps = {
    serviceURL: DL_SERVICE_URL,
    stationNum: 0,
    isFactSheet: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      formPresented: false,
      submitted: this.props.downloadOpen,
      dlFinishedMsg: false,
      privacyOpen: false,
      permissionsOpen: false,
    };

    this.cookieData = getContactCookie();
  }

  componentDidMount() {
    if (this.props.title) {
      this.props.dispatch(SetModalTitle(this.props.title));
    }
  }

  fromCookies(key) {
    return this.cookieData[cookieFieldMap[key]] || "";
  }

  updateCookies(formData) {
    const contactInfo = {};
    for (var k in formData) {
      if (k in cookieFieldMap) {
        if (formData.rememberMe) {
          contactInfo[cookieFieldMap[k]] = formData[k];
        } else {
          contactInfo[cookieFieldMap[k]] = "";
        }
      }
    }
    setContactCookie(contactInfo);
  };

  getFormData() {
    const { id } = this.props;
    const formData = {};
    const inputs = d3.selectAll(`#${id} .contact_form input,
                                 #${id} .contact_form textarea,
                                 #${id} .contact_form select`);
    inputs.nodes().forEach((input) => {
      if (input.type === "checkbox") {
        formData[input.name] = input.checked;
      } else {
        formData[input.name] = input.value;
      }
    });

    this.updateCookies(formData);

    return formData;
  }

  objToURIString = obj => {
    var str = [];
    for (var p in obj) {
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    }
    return str.join("&");
  };

  doDownload = (_) => {
    const { dispatch, dlCallback, dlType, productID } = this.props;

    const dlFinishedCb = (err, link, filename) => {
      if (err) {
        gaEvent('download', 'error', `${productID}-${dlType}`);
        owlSend({
          agent: "ssrf-mon",
          entity: "ssrf-download",
          message: err + `${productID}-${dlType}`
        });
        this.setState({dlFinishedMsg: <p>There was a problem processing your request. Surging Seas support has been
        notified of the issue. Please contact sealevel@climatecentral.org if you have any questions.</p>});
      } else {
        gaEvent('download', 'complete', `${productID}-${dlType}`);
        dispatch(SetModalTitle("Download complete"));
        this.adWordsCallback();
        this.setState({dlFinishedMsg: <div className="DownloadForm">
          <h2 style={{textAlign: "center"}}><strong>Download ready</strong></h2>
          <p style={{textAlign: "center"}}>
            If your file did not download automatically, please&nbsp;
            {filename ? <a href={link} download={filename} target="_blank">click here</a> :
                <a href={link} target="_blank">click here</a>} to download. Enjoy.
          </p>
          <hr />
        </div>});
      }
    };

    if (dlType === "fact-sheet") {
      dispatch(SetModalTitle("Generating fact sheet"));
    } else {
      dispatch(SetModalTitle("Retrieving download"));
    }

    gaEvent('download', 'submit', `${productID}-${dlType}`);
    dlCallback(dlFinishedCb.bind(this));
  };

  createContact = (postData) => {
    const { serviceURL } = this.props;
    const formUrl = `${serviceURL}/create-contact`;
    submitForm(formUrl, postData);
    this.setState({ submitted: true });
  };

  handleFormSubmit = (e) => {
    e.preventDefault();
    const { dlType, productID } = this.props;
    const formData = this.getFormData();
    const postData = this.objToURIString(formData);
    this.createContact(postData);
    gaEvent('download', 'formpost', `${productID}-${dlType}`);
  };

  adWordsCallback() {
    /* <![CDATA[ */
    var goog_snippet_vars = function() {
      var w = window;
      w.google_conversion_id = 979518184;
      w.google_conversion_label = "AdspCNDk0WwQ6IWJ0wM";
      w.google_remarketing_only = false;
    };
    // DO NOT CHANGE THE CODE BELOW.
    var goog_report_conversion = function(url) {
      goog_snippet_vars();
      window.google_conversion_format = "3";
      var opt = new Object();
      opt.onload_callback = function () {
        if (typeof(url) != 'undefined') {
          window.location = url;
        }
      };
      var conv_handler = window['google_trackConversion'];
      if (typeof(conv_handler) == 'function') {
        conv_handler(opt);
      }
    };

    goog_report_conversion();
  }

  customAnalysisClick(category) {
    gaEvent(`custom-analysis-${this.props.downloadFormID}`, 'click', category);
  }

  render() {
    const { productID, dlType } = this.props;
    const productName = `Surging Seas Risk Finder ${productID} ${dlType}`;
    const lang = Transifex.live.getSelectedLanguageCode();
    this.cookieData = getContactCookie();
    var previewPath;
    if (this.props.dlType === "eae-img") {
      previewPath = `/static/thumbnails/forecast-png-preview.jpg`;
    } else if (this.props.dlType === "eae-pptx") {
      previewPath = `/static/thumbnails/forecast-pptx-preview.jpg`;
    } else {
      previewPath = `/static/thumbnails/${this.props.dlType}-preview.jpg`;
    }

    const facebookPreDownloadPixel = () => {
      return ({__html: `fbq('trackCustom', 'PageView', {downloadID: '${productID}-${dlType}', siteHost: '${window.location.hostname}'});`});
    };

    const facebookDownloadPixel = () => {
      return ({__html: `fbq('trackCustom', 'Download', {downloadID: '${productID}-${dlType}', siteHost: '${window.location.hostname}'});`});
    };

    const customAnalysis = (
        <div style={{maxWidth: 768}}>
          <h3><em>NEW:</em>  COASTAL ANALYSIS TAILORED FOR YOU</h3>
          <p>If you find our public tools useful, you may be interested in our coastal products and services.</p>
          <img
              src="http://sealevel.climatecentral.org/images/uploads/3_images.png"
              style={{width: "100%", marginBottom: "10px"}}
          />
          <p>Climate Central now offers custom flood risk analytics, maps and tools. Sea level rise and coastal
             area flooding are growing threats worldwide. We can help you:</p>
          <br />
          <div>
            <strong>Plan:</strong> Where should I buy, sell, build, or move?
          </div>
          <div>
            <strong>Protect:</strong> What do I need to protect, by how much, and when?
          </div>
          <div>
            <strong>Assess:</strong> What is the threat to my existing portfolio, assets, or infrastructure?
          </div>
          <br />
          <p>
            With U.S. and global coverage, we offer big data analytics, digital maps & tools, tailored services,
            and consulting for governments, NGOs, businesses, consultants and investors.
            Contact us for more information and pricing.
          </p>
          <br />
          <a href="http://sealevel.climatecentral.org/maps/custom-analysis" target="_blank">
            <button className="submit" onClick={this.customAnalysisClick.bind(this, "learn-more")}>Learn more + contact form</button>
          </a>
          <br />
        </div>
    );

    const beforeForm = (
        <div className="DownloadForm dl-before-form">
          <script dangerouslySetInnerHTML={facebookPreDownloadPixel()} />
          <div className="column">
            {this.props.children}
            <div className="button-block">
              <button onClick={() => this.setState({formPresented: true})} className="submit dl-before-form-button">Get download</button>
              <p className="dl-note">To customize differently, close this window and adjust tool settings.</p>
            </div>
            <img className="dl-preview" src={previewPath} />
          </div>
          <div className="column right">
            {customAnalysis}
          </div>
        </div>
    );

    const form = (
      <div id={this.props.id} className="DownloadForm">
        <h3>HELP IMPROVE OUR PRODUCTS</h3>
        {this.state.submitted ?
            <p>Thank you! Your input will help us better understand your needs. </p> :
            <div>
              <p className="">While we create your download, please help us improve our products by filling
          in this form. Your answers will help us understand our audience and improve our offerings. We won't
          share your personal information. <strong>All fields are optional</strong>.
              </p>
              <div className="">
                <div className="contact_form">
                  <form id="screenshot_form" onSubmit={this.handleFormSubmit}>
                    <input type="hidden" name="formId" value="urkETxRDcHJrtnrSt5lPJA==" />
                    <input type="hidden" name="emails[0].Label" value="Work" />
                    <input type="hidden" name="Product" value={productName} />
                    <input type="hidden" name="Language" value={lang} />

                    <div className="full-width">
                      <label htmlFor="insightly_firstName">Name </label>
                      <input id="insightly_firstName" name="FirstName" type="text" defaultValue={this.fromCookies("FirstName")}  />
                    </div>

                    <div className="full-width">
                      <label htmlFor="insightly_organization">Organization Name, or 'Self' </label>
                      <input id="insightly_organization" name="organization_name" type="text" defaultValue={this.fromCookies("Organization")} />
                    </div>

                    <div className="full-width">
                      <label htmlFor="insightly_organizationType">Organization Type </label>
                      <select id="insightly_organizationType" name="organization_type" defaultValue={this.fromCookies("phones[1].Value")} >
                        <option value="" disabled />
                        <option value="Academic">Academic</option>
                        <option value="Corporate">Corporate</option>
                        <option value="Government">Government</option>
                        <option value="Non-Profit">Non-Profit</option>
                        <option value="Individual (No Affiliation)">Individual (No Affiliation)</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    <div className="full-width">
                      <label htmlFor="emails[0]_Value">Email </label>
                      <input id="emails[0]_Value" name="emails[0].Value" type="email" defaultValue={this.fromCookies("emails[0].Value")}  />
                    </div>

                    <div className="full-width">
                      <label htmlFor="insightly_background">Intended Use </label>
                      <textarea id="insightly_background" name="background"  />
                    </div>
                    <div className="full-width">
                      <label><input name="rememberMe" type="checkbox" defaultChecked /> Save form entries for future downloads</label>
                    </div>
                    <button onClick={this.doDownload} className="submit dl-before-form-button">Download now</button>
                  </form>
                </div>
              </div>
            </div> }
      </div>
    );

    const footer = (
      <div>
        <hr style={{clear: "both"}} />
        <p className="detail">Climate Central is a donor-supported not-for-profit organization dedicated to providing
    a wide range of free and accessible analyses and maps to the public.
        </p>
        <p className="dl-form-supertitle">PRIVACY</p>
        <p className="detail">No personally identifying information entered in this form will be shared without written permission.
        See our <a href="https://www.climatecentral.org/what-we-do/legal" target="_blank">Privacy Policy</a> for more details.
        </p>
        <p className="dl-form-supertitle">PERMISSIONS</p>
        <p className="detail">Again, we welcome you to share these materials widely. Please cite Climate Central in any publication
    utilizing them, include a link to <a href="http://sealevel.climatecentral.org/" target="_blank">http:&#47;&#47;sealevel.climatecentral.org&#47;</a> if
        they are used online, and adhere to our <a href="https://www.climatecentral.org/what-we-do/legal" target="_blank">terms of use</a>.
        </p>
      </div>
    );

    this.dlWaitMsg = (
        <div>
          {customAnalysis}
          {footer}
        </div>
    );

    const afterForm = (
      <div>
        <div className="DownloadForm">
          <script dangerouslySetInnerHTML={facebookDownloadPixel()} />
          {this.state.dlFinishedMsg ? this.state.dlFinishedMsg
              :
              <div>
                <Loader loaded={this.state.dlFinishedMsg} top="25px" left="50%" />
                <div style={{height: "50px"}}></div>
                <hr />
                <p>Preparing Surging Seas download for you. This may take a minute. Thanks for your patience.
              We welcome you to use and share broadly! See privacy and permissions policies below.
                </p>
                <hr />
              </div>
          }
            {this.dlWaitMsg}
          </div>
      </div>
    );

    return (!this.state.formPresented ? beforeForm
          : (!this.state.submitted ? form : afterForm));
  }

}

export default compose(
  withStyles(styles),
  connect((state) => {return {downloadFormID: state.downloadFormID};}),
)(DownloadForm);
